import React, { useEffect, useState } from 'react';
import { billingService, type SubscriptionStatus } from '../services/api';

const SubscriptionBadge: React.FC = () => {
  const [sub, setSub] = useState<SubscriptionStatus | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await billingService.getSubscription();
        setSub(res.data);
      } catch {
        setSub(null);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, []);

  if (loading || !sub?.isPro) return null;

  return (
    <span className="inline-flex items-center px-2 py-0.5 text-[11px] font-semibold tracking-wide text-brand-500 bg-brand-50 border border-brand-100 rounded-full">
      PRO
    </span>
  );
};

export default SubscriptionBadge;
